import { useState, useEffect } from "react";
import Background from "assets/images/announcement-bg.svg";
import styles from "./style.module.scss";
import axios from "axios";
import LoaderSpinner from "../../UI/LoaderSpinner/LoaderSpinner";
import { AnnouncementModelResponse } from "types";
import AuthService from "services/AuthService";
import { useKeycloak } from "@react-keycloak/web";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

const DashboardAnnouncements = () => {
  const [announcementList, setAnnouncement] = useState<AnnouncementModelResponse | []>(null!);
  const [isLoading, setIsLoading] = useState(false);
  const { keycloak } = useKeycloak();

  const auth = new AuthService(keycloak);

  const getAnnouncementList = async () => {
    setIsLoading(true);

    auth.axios(`/Announcement/GetAnnouncementList`, null, null)
      .then((response) => {
        setIsLoading(false);
        if (response.data.success === true) {
          setAnnouncement(response.data.data.itemList);
        } else {
          if (response.data.message) {
            toast.error(response.data.message, {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);

        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    getAnnouncementList();
  },[]);

  return (
    <div>
      <ToastContainer />
      <div className={styles.announcement}>
        <img src={Background} alt="" />
        <div className={styles.header}>
          <div className={styles.left}>Son Duyurular</div>
          {/* <div className={styles.right}>Tamamını Görüntüle {" >"}</div> */}
        </div>
        <div className={styles.tableCustom}>
          <div className={styles.customHeader}>
            <div>Tarih</div>
            <div>Duyuru</div>
          </div>
          <div className={styles.customContent}>
            {announcementList?.map((item) => (
              <div key={item.id} className={styles.contentContainer}>
                <div>{item.created}</div>
                <div>{item.content}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAnnouncements;
